module.exports = "/_next/static/images/whats-murder-island-image-video-71eacc09535348a6bed581b9b3290126.png";